import { useEffect } from "react";
import styles from "../../styles/modal.module.css";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
interface IProps {
  onClose: () => void;
  actions: {
    continue: () => void;
  };
}

const QRModal = ({ onClose, actions }: IProps) => {
  const {t} = useTranslation();
  useEffect(()=>{
    if(sessionStorage.getItem("showQRPopup")){
      sessionStorage.removeItem("showQRPopup")
    }
  },[])
  return (
    <div className={styles.qrModalContent}>
      <div onClick={onClose} title="Close">
        <img src="/assets/cross.png" className={styles.crossWrap} />
      </div>
      <div className={styles.qrModalBody}>
        <div className={styles.modalTitle}>{t('qrmodal.title')}</div>
        <div className={styles.qrCodeContainer}>
          <QRCodeCanvas
            value={`${window.location.origin}/?locale=${i18next.language}`}
            size={198}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
          />
        </div>
        <div className={styles.modalDescription}>
        {t('qrmodal.description')}
        </div>
      </div>
    </div>
  );
};

export default QRModal;
